export default "__VITE_ASSET__ksq9eG9r__"